module.exports = __webpack_public_path__ + "static/media/bruce-mars.c0421fd9.jpg";